import { render, staticRenderFns } from "./place_inspection_recommendations.vue?vue&type=template&id=f07f4bae&scoped=true&"
import script from "./place_inspection_recommendations.vue?vue&type=script&lang=js&"
export * from "./place_inspection_recommendations.vue?vue&type=script&lang=js&"
import style0 from "./place_inspection_recommendations.vue?vue&type=style&index=0&id=f07f4bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07f4bae",
  null
  
)

export default component.exports